<div class="flex flex-col gap-6" *ngIf="showOnPropertiesPage$ | async">
	<h4>
		Property value<ng-container *ngIf="showLtvData$ | async">
			&amp; LTV</ng-container
		>
	</h4>

	<div class="flex flex-col">
		<app-input
			label="Property value"
			[ngModel]="propertyValue$ | async"
			(debounce)="onPropertyValueChanged($event)"
			type="cents"
			[testHook]="testHooks.PropertyValue"
		></app-input>
		<app-button
			*ngIf="showPropertyValueSetToAps$ | async"
			cssClasses="text-sm p-0"
			btn="link"
			size="xsmall"
			(onClick)="onSetToApsPropertyValueClick()"
			[testHook]="testHooks.SetToSalePriceButton"
			>Set to sale price</app-button
		>
	</div>

	<app-dropdown
		label="Source of property value"
		[itemGroups]="sourceOptions$ | async"
		(onSelect)="onSourceSelect($event.result.value)"
		[value]="ltvSourceLabels[source$ | async]"
		[testHook]="testHooks.SourceOfPropertyValueDropdown"
	></app-dropdown>

	<app-input
		*ngIf="showCustomSource$ | async"
		label="Custom source of property value"
		[ngModel]="customSource$ | async"
		(debounce)="onCustomSourceChanged($event)"
		[testHook]="testHooks.CustomSourceOfPropertyValue"
	></app-input>

	<ng-container *ngIf="showLtvData$ | async">
		<h4>Outstanding mortgage amount</h4>
		<ng-container
			*ngFor="let mortgage of mortgages$ | async; trackBy: trackMortgageBy"
		>
			<app-mortgage-summary-tile
				class="rounded-md bg-grey-lightest hover:bg-white hover:shadow hover:cursor-pointer p-3"
				[mortgage]="mortgage"
				(click)="onMortgageClick(mortgage)"
			></app-mortgage-summary-tile>
		</ng-container>

		<div class="flex flex-col">
			<app-input
				label="Total outstanding mortgage amount"
				[ngModel]="outstanding$ | async"
				(debounce)="onOutstandingChanged($event)"
				type="cents"
				[testHook]="testHooks.TotalOutstandingMortgageAmount"
			></app-input>
			<app-button
				*ngIf="isOutstandingNotEqualToCalculated$ | async"
				cssClasses="text-sm p-0"
				btn="link"
				(onClick)="onSetToCalculatedValueClick()"
				size="xsmall"
				[testHook]="testHooks.SetToCalculatedValueButton"
				>Set to calculated value</app-button
			>
		</div>

		<div
			class="flex justify-between p-3 gap-3 rounded-md bg-grey-lightest items-center"
		>
			<div class="text-xl">Combined Loan to Value</div>
			<div class="text-2xl font-bold">{{ ltvPercentage$ | async }}%</div>
		</div>
	</ng-container>
</div>
